import React from 'react';
import { logoutPatient } from '../../../redux/middleware/user/patient/auth/login';
import { APP_URLS } from '../../../../urls';
import { showToast } from './helpers';

export const handleLogout = async (toast, dispatch, navigate) => {
  try {
    const logoutResponse = await dispatch(logoutPatient());

    if (logoutResponse.status === 200) {
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('patientCredentials');

      dispatch({
        type: 'patient-login/SET_PATIENT_AUTHENTICATED',
        payload: false
      });
      dispatch({
        type: 'patient-login/SET_PATIENT_CREDENTIALS',
        payload: null
      });
      navigate(APP_URLS.patientLogin);
    }
  } catch (error) {
    showToast(
      toast,
      'error',
      error.response?.message ||
				error.response?.detail ||
				'An unexpected error occurred during logout. Please try again!'
    );
  }
};
